import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=70b91b0d&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=70b91b0d&prod&lang=css"
import style1 from "./CommonHeader.vue?vue&type=style&index=1&id=70b91b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b91b0d",
  null
  
)

export default component.exports